// extracted by mini-css-extract-plugin
export default {"root":"CaseDetailsDate_root__c+r9J"};